/**
 * Resolve a translation key from Nitro-cached Shopware snippets (`/api/snippets/:locale`),
 * then fall back to vue-i18n `t()` — same behaviour as template `$t` after `plugins/appTranslation.ts`.
 */
export const useSnippetT = () => {
  const { t, locale } = useI18n();
  const { snippetData, fetchSnippetSet } = useSnippets();

  const snippetT = (key: string) => {
    const hit = snippetData.value?.snippets?.[key];
    if (hit !== undefined && hit !== null) {
      return hit;
    }
    return t(key);
  };

  void fetchSnippetSet();

  watch(locale, () => {
    void fetchSnippetSet();
  });

  return {
    snippetT,
    snippetData,
    fetchSnippetSet,
  };
};
